

import React, { useState } from 'react';
import {  HiOutlinePhone } from "react-icons/hi";

import { Link, useNavigate } from 'react-router-dom';
import { backendurl } from '../../Servicepage';
import { FaRegUser } from 'react-icons/fa';
import { toast } from 'react-toastify';
import '../../assets/Userloginpage.css'; 

function Myforgetpage() {
    const usenav = useNavigate();

    const [userlogin, usersetlogin] = useState({
        phone: "",
        fullname: "",
        dob:""
    });

    const updateinput = (e) => {
        const { name, value } = e.target;
        usersetlogin((prevState) => ({
            ...prevState,
            [name]: value
        }));
    };

    const mylogin = async () => {
        const { phone, fullname,dob } = userlogin;
        if (phone === "" || fullname === ""|| dob==="") {
            toast.error("Email and password cannot be blank");
        } else {
            try {
                const response = await fetch(`${backendurl}/mylogin`, {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({ phone, fullname,dob })
                });
                const res = await response.json();
                if (res.status === 422) {
                    toast.success("Login Successful");
                    usenav('/dashboard');
                } else {
                    toast.error("Login failed");
                }
            } catch (error) {
                toast.error("An error occurred");
            }
        }
    };

    return (
        <div className="login-container">
            <div className="login-card">
                <div className="header text-center mb-4">
                    <FaRegUser className="icon" />
                    <h2>User Login</h2>
                </div>
                <div className="form-group">
                    <label className="form-label">
                        <HiOutlinePhone /> phone No
                    </label>
                    <input
                        type="text"
                        className="form-control"
                        placeholder="Enter Phone No"
                        name="phone"
                        onChange={updateinput}
                    />
                </div>
                <div className="form-group">
                    <label className="form-label">
                         fullname
                    </label>
                    <input
                        type="text"
                        className="form-control"
                        placeholder="fullname"
                        name="fullname"
                        onChange={updateinput}
                    />
                </div>
                <div className="form-group">
                    <label className="form-label">
                         Date Of Birth
                    </label>
                    <input
                        type="date"
                        className="form-control"
                        placeholder="dob"
                        name="dob"
                        onChange={updateinput}
                    />
                </div>
                <div className="button-group text-center">
                    <button type="button" className="btn btn-success" onClick={mylogin}>
                        Submit
                    </button>
                    <button type="reset" className="btn btn-danger ms-3">
                        Reset
                    </button>
                    <Link to="/registor" className="btn btn-primary mt-2 ms-3">
                        New Register
                    </Link>
                   
                   
                </div>
            </div>
        </div>
    );
}

export default Myforgetpage;
